import React from 'react';
import './index.scss';

const EvacuationZonesContainer = props => {
	return <div className="evacuation-zones-container">{props.children}</div>;
};

export default EvacuationZonesContainer;



// WEBPACK FOOTER //
// ./src/pages/evacuation-demo/containers/evacuation-zones-container/index.js